// File: src/blueprint/components/content/info/InfoContent.jsx

import BlockRenderer from '../renderers/BlockRenderer.jsx';

function asArray(v) {
  return Array.isArray(v) ? v : [];
}

export default function InfoContent({ item }) {
  const title = item?.title ? String(item.title) : '';
  const subtitle = item?.subtitle ? String(item.subtitle) : '';
  const body = item?.body ? String(item.body) : '';

  const blocks = asArray(item?.blocks);

  return (
    <div>
      {title ? <h2 className="dv-br-stepHeader__title">{title}</h2> : null}
      {subtitle ? <p className="dv-br-card__text dv-br-card__muted">{subtitle}</p> : null}

      {/* body */}
      {body ? <p className="dv-br-card__text">{body}</p> : null}

      {/* blocks */}
      {blocks.length > 0 ? (
        <div style={{ marginTop: 16 }}>
          {blocks.map((block, index) => (
            <BlockRenderer key={block?.id || `info-block-${index}`} block={block} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
